import { ChevronLeft } from '../icons.js';
import { TaskList } from '../list/TaskList.js';

import { ProgressCount } from './ProgressCount.js';

import type { TaskExtras, TaskHandlers } from '../task/TaskParts.js';
import type { ProjectProgress, Task } from '@nedelnik/shared';

/**
 * Просмотр проекта: его задачи из всех спринтов сразу, а не срез одной недели
 * (3.8.8).
 *
 * В этом и смысл зонтика — задачи одного проекта живут в разных спринтах и во
 * Входящих (3.8.4), и собрать их вместе можно только здесь. Спринт каждой
 * задачи виден на её степпере, поэтому отдельной колонки «когда» не нужно.
 *
 * Показывается всегда список, а не доска: доска — про один спринт, и три
 * колонки поверх всех недель сразу перестают что-либо значить.
 *
 * Статусы проекта и вложенных не связаны (3.8.9): здесь нет ни одного
 * действия, которое трогало бы проект при закрытии вложенной задачи, и
 * наоборот.
 */
export function ProjectView({
  project,
  nested,
  progress,
  extras,
  handlers,
  onBack,
  backLabel,
}: {
  project: Task;
  /** Вложенные задачи — из всех спринтов сразу (3.8.8). */
  nested: readonly Task[];
  progress: ProjectProgress;
  extras: TaskExtras;
  handlers: TaskHandlers;
  onBack: () => void;
  backLabel: string;
}): React.ReactElement {
  return (
    <section className="screen">
      <header className="screen__head">
        {/*
          Имя начинается с «Назад», а видимая подпись входит в него целиком:
          иначе в озвучке это просто «Сентябрь, кнопка» — слово, которое ничего
          не обещает. Требование «видимый текст — часть имени» при этом
          соблюдено.
        */}
        <button type="button" className="link" aria-label={`Назад: ${backLabel}`} onClick={onBack}>
          <ChevronLeft />
          {backLabel}
        </button>
        <h1>{project.title}</h1>
        <div className="screen__marks">
          <ProgressCount progress={progress} />
          <button type="button" className="link" onClick={() => handlers.onOpen(project)}>
            открыть саму задачу
          </button>
        </div>
        <p className="head__sub">задачи проекта из всех спринтов</p>
      </header>

      {nested.length === 0 ? (
        <div className="empty">
          <p>В проекте не осталось задач.</p>
          <p>Вложить задачу можно из её карточки — строка «Проект».</p>
        </div>
      ) : (
        <TaskList tasks={nested} extras={extras} handlers={handlers} />
      )}
    </section>
  );
}
